const BACKEND = {
        ADDRESS: 'https://www.coachathlon.com:8854'
    //    ADDRESS: 'http://localhost:8855' //local server
    };
    
export { BACKEND };